export default "__VITE_PUBLIC_ASSET__15c4d3dd__"